import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { AxiosError } from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { axiosPrivate } from "../../utils/axiosInstance";
import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Chip,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Snackbar,
  Stack,
} from "@mui/material";
import { GetAllVersions, GetDeviceData, UploadYaml } from "../../Api";

/**
 * @typedef {Interface} appParams
 * @param {String} sessionID
 * @param {String} fileName
 */
export type appParams = {
  sessionID: string;
  fileName: string;
};

interface Props {
  deploySelected: string;
  setDeploySelected: any;
}

/**
 * Component for deploying a YAML file on an instance.
 *
 * @returns {JSX.Element} The JSX element representing the deployment component.
 */
export function DeployComponent({ deploySelected, setDeploySelected }: Props) {
  // const navigate = useNavigate();
  const { sessionID, fileName } = useParams<appParams>();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [versionName, setVersionName] = useState<string>("bugfix");
  // const [selectedVersion, setSelectedVersion] = useState<any>();
  const [selectedDevice, setSelectedDevice] = useState<any>();
  const [deviceData, setDeviceData] = useState<any[]>();
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error";
  }>({ open: false, message: "", severity: "success" });
  const [tagInput, setTagInput] = useState('');
  const [tags, setTags] = useState<string[]>([]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (['Enter', ' ', ','].includes(e.key)) {
      e.preventDefault();
      const newTag = tagInput.trim();
      if (newTag && !tags.includes(newTag)) {
        setTags([...tags, newTag]);
      }
      setTagInput('');
    }
  };

  const handleDelete = (tagToDelete: string) => {
    setTags(tags.filter((tag) => tag !== tagToDelete));
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  function upgradeVersion(currentVersion: string, level: string): string {
    // Split the current version name into major, minor, and patch parts
    // Remove optional 'v' prefix
    const version = currentVersion.startsWith("v") ? currentVersion.slice(1) : currentVersion;

    const parts = version.split(".");
    if (parts.length !== 3) {
      throw new Error("Invalid version format. Expected format: x.y.z");
    }

    const [majorStr, patchStr, bugfixStr] = parts;
    const major = parseInt(majorStr, 10);
    const patch = parseInt(patchStr, 10);
    const bugfix = parseInt(bugfixStr, 10);


    if (level === "major") {
      return `v${major + 1}.0.0`;
    } else if (level === "minor") {
      return `v${major}.${patch + 1}.0`;
    } else if (level === "bugfix") {
      return `v${major}.${patch}.${bugfix + 1}`;
    } else {
      throw new Error("Invalid upgrade level");
    }
  }
  /**
   * Get the session information.
   */
  const getSession = async () => {
    axiosPrivate
      .get(`/mqttapi/v1/session/${sessionID}`)
      .then((resp: any) => {
        // getDeployServers(resp.data);
      })
      .catch((error: AxiosError) => {
        console.log(`${error.response?.data}`);
      });
  };
  useEffect(() => {
    fetchDeviceData();
  }, []);

  const fetchDeviceData = async () => {
    try {
      // setLoader(true);
      const result: any = await GetDeviceData();
      const getVersions = await GetAllVersions()
      // console.log(result);
      const latustVersions = result?.map((device: any) => {
      const matchedVersion = [...getVersions].reverse().find(
        (version: any) => version?.deviceID === device?.deviceID
      );

      return matchedVersion
        ? { ...device, firmwareVersion: matchedVersion.version }
        : device;
      });
      setDeviceData(latustVersions);
      // setLoader(false);
    } catch (error) {
      console.log("Error:", error);
    }
  };
  const handleClose = () => {
    setOpenModal(false);
  };
  const handleSubmit = async () => {
    const Actualversion = upgradeVersion(
      selectedDevice.firmwareVersion,
      versionName
    );

    const body = { device: selectedDevice.deviceID, version: Actualversion, tags: JSON.stringify(tags) };

    try {
      const result = await UploadYaml(
        `${window.location.origin}/mqttapi/v1/session/${sessionID}/deploy/${fileName}`,
        body
      );
      if (result.success === "file uploaded successfully") {
        setSnackbar({
          open: true,
          message: "processing started for make firmware",
          severity: "success",
        });
      } else {
      }
    } catch (error) {}
    // Handle form submission logic here
    setOpenModal(false);
  };
  return (
    <>
      <Button
        variant="outlined"
        color="warning"
        onClick={() => setOpenModal(true)}
        sx={{ fontWeight: "bold", marginLeft: "10px" }}
      >
        Compile
      </Button>

      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography
            fontSize={"17px"}
            fontWeight={"bold"}
            id="modal-title"
            variant="h3"
            component="h2"
            gutterBottom
            marginBottom={"10px"}
          >
            Compile This Flow Into Machine Code.
          </Typography>
          <Grid>
            <FormControl fullWidth style={{ marginBottom: "10px" }}>
              <InputLabel id="device-id-label">Target Device</InputLabel>
              <Select
                labelId="device-id-label"
                id="device-id"
                value={!selectedDevice ? "" : selectedDevice.deviceID}
                onChange={(e: SelectChangeEvent<string>) =>
                  setSelectedDevice(
                    deviceData?.length &&
                      deviceData?.find(
                        (data: any) => data?.deviceID === e.target.value
                      )
                  )
                }
                label="Target Device"
              >
                {!deviceData ? <MenuItem value={""}>{"Loading..."}</MenuItem> : deviceData.length === 0 ? <MenuItem value={""}>{"No data available"}</MenuItem> : deviceData &&
                  deviceData.length > 0 &&
                  deviceData?.map((data: any, i: any) => {
                    return (
                      <MenuItem value={data?.deviceID}>
                        {data?.deviceID}
                      </MenuItem>
                    );
                  })}
                {/* <MenuItem value="ESP32">ESP32</MenuItem>
                    <MenuItem value="1">Device Type 1</MenuItem>
                    <MenuItem value="2">Device Type 2</MenuItem> */}
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel id="demo-row-radio-buttons-group-label">
                OTA Release Type
              </FormLabel>
              <RadioGroup
                row
                defaultValue="bugfix"
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                onChange={(e) => setVersionName(e.target.value)}
              >
                <FormControlLabel
                  value="bugfix"
                  control={<Radio />}
                  label="Bug fix"
                />
                <FormControlLabel
                  value="minor"
                  control={<Radio />}
                  label="Minor"
                />
                <FormControlLabel
                  value="major"
                  control={<Radio />}
                  label="Major"
                />
              </RadioGroup>
            </FormControl>
            <FormControl fullWidth style={{ marginBottom: '10px' }}>
            <TextField
              fullWidth
              id="tag"
              label="Add Tags"
              variant="outlined"
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Type and press Enter, comma or space"
            />
            <Box mt={1} sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {tags.map((tag, index) => (
                <Chip
                  key={index}
                  label={tag}
                  onDelete={() => handleDelete(tag)}
                  color="primary"
                  variant="outlined"
                />
              ))}
            </Box>
          </FormControl>
          </Grid>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="flex-end"
            sx={{ mt: 3 }}
          >
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleClose}>
              Cancel
            </Button>
          </Stack>
        </Box>
      </Modal>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
